import React, { useState, useEffect } from "react";
import { PA_API_ENDPOINTS } from "../constants/apiconfig/proteoarkApiconfig";
import axios from "axios";

const AuthContext = React.createContext({
  token: "",
  isLoggedIn: false,
  login: (token, refreshToken, expirationTime) => {},
  logout: () => {},
});

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();
  const remainingDuration = adjExpirationTime - currentTime;

  return remainingDuration;
};

export const AuthContextProvider = (props) => {
  const initialToken = localStorage.getItem("token");
  const [token, setToken] = useState(initialToken);
  const userIsLoggedIn = !!token;

  const logoutHandler = () => {
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  };

  const loginHandler = (token, refreshToken, expirationTime) => {
    setToken(token);
    localStorage.setItem("token", token);
    localStorage.setItem("refreshToken", refreshToken);

    // Calculate remaining time based on the expiration time
    const remainingTime = calculateRemainingTime(expirationTime);
    setTimeout(logoutHandler, remainingTime);
  };

  const refreshAccessToken = async () => {
    const refreshUrl = PA_API_ENDPOINTS.REFRESH_TOKEN;
    const storedRefreshToken = localStorage.getItem("refreshToken");

    if (storedRefreshToken) {
      try {
        const response = await axios.post(
          refreshUrl,
          { refresh_token: storedRefreshToken },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = response.data;

        const newToken = data.access;
        const newRefresh = data.refresh;
        const expirationTime = new Date(new Date().getTime() + 60 * 60000);
        loginHandler(newToken, newRefresh, expirationTime);
      } catch (error) {
        console.error("Failed to refresh token:", error);
        logoutHandler();
      }
    }
  };

  useEffect(() => {
    if (token) {
      const interval = setInterval(refreshAccessToken, 55 * 60000); // 55 minutes
      return () => clearInterval(interval);
    }
  }, [token]);

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
